import Presenter from "./presenter.component";

angular
  .module("acl.storyboard.presenter", ["acl.storyboard.presenter.keyshortcut"])
  .component("aclStoryboardPresenter", Presenter);
